import { clientData } from "$lib/client-data/index.svelte.js";
import { showModal } from "$lib/components/Modal";
import { goto } from "$app/navigation";
import { getToken, clearUser } from "$lib/client-data/user";
import Cookies from "js-cookie";

const getDefaultHeaders = ({ encrypt, token, clientId } = {}) => ({
  "app-info": JSON.stringify({ os: "Android", channel: "ZH9B", clientVersion: "1.0.0" }),
  "Android-DeviceId": "2eb9340bf7df63638b9920f41e8aaeb1b",
  "Content-Type": "application/json;charset=UTF-8",
  "X-TENANT-CODE": clientData.apiConfig.tenant,
  "X-DEVICE-ID": clientData.deviceId || "H5|000",
  "X-APP-VERSION": "2.5.1",
  "X-CHANNEL": "H5",
  "X-TIMESTAMP": Date.now(),
  "Request-Encrypt": !!encrypt,
  Lang: "zh_CN",
  "X-AUTH-TOKEN": token || getToken(),
});

const waitingLogin = () => {
  return new Promise((resolve) => {
    let timer = null;
    let times = 0;
    timer = setInterval(() => {
      times++;
      if (getToken() || times >= 20) {
        clearInterval(timer);
        resolve(true);
      }
    }, 10);
  });
};

async function request(url, method = "GET", { encrypt, token, clientId, responseType = "json", headers, ...options } = {}) {
  if (!getToken() && url.indexOf("visitor/auth") == -1) {
    await waitingLogin();
  }
  try {
    let sendHeaders = { ...getDefaultHeaders({ encrypt, token, clientId }), ...headers };
    if (sendHeaders["Content-Type"] == "multipart/form-data") {
      delete sendHeaders["Content-Type"];
    }
    let d = {};

    // const res = await fetch(url.startsWith("http") ? url : clientData.apiConfig.apiUrl ? `${clientData.apiConfig.apiUrl}${url}` : url, {
    const res = await fetch(url.startsWith("http") ? url : `/clientapi${url}`, {
      ...options,
      method,
      headers: sendHeaders,
    });
    if (responseType === "json") d = await res.json();

    if (!res.ok) return { success: false, msg: d?.msg || "获取数据错误", status: res.status, error: d, request: { url, method, headers } };
    if (responseType === "arraybuffer") d = await res.arrayBuffer();

    // 添加响应头中的 Date，转换为东八区时间戳
    if (res.headers.get("Date")) {
      const dateString = res.headers.get("Date");
      const utcTimestamp = new Date(dateString).getTime();
      const eastEightTimestamp = utcTimestamp + 8 * 60 * 60 * 1000;
      d.responseDate = eastEightTimestamp;
    }

    if (d.code == 401) {
      showModal({
        title: "温馨提示",
        status: "warn",
        content: d.msg || "未登录，请登录后重试~",
        onConfirm: () => {
          clearUser();
          goto("/auth/login");
        },
        confirmText: "确定",
        showCancelButton: false,
      });
    } else if (d.code == 403) {
      // HTTP 403错误状态对照（msg）
      // 101 token过期
      // 103 IP白名单校验未通过
      // 105 授权token与使用token设备号一致性校验未通过
      // 107 API授权商信息校验未通过
      // 109 登录会员token非法(未登录访客token调用登录权限接口)
      if (Cookies.get("token")) {
        showModal({
          title: "温馨提示",
          status: "warn",
          content: "登录超时，请重新登录",
          onConfirm: () => {
            clearUser();
            goto("/auth/login");
          },
          confirmText: "确定",
          showCancelButton: false,
        });
      }
      else {
        clearUser();
        goto("/auth/login");
      }
      // switch (d.msg) {
      //   case "103":
      //   // localStorage.removeItem('DEVICEID');
      //   case "101":
      //   case "105":
      //     // removeSession('auth');
      //     // const { auth } = getUrlQuery();
      //     // if (!auth) {
      //     //   await getAuth(); // 重新获取auth接口
      //     //   return Promise.reject({}); //403重新获取auth token 不作任何提示
      //     // }
      //     break;
      //   case "107":
      //     showToast("代理信息校验失败，请联系客服");
      //     break;
      //   case "109":
      //     break;
      //   default:
      //     // showToast(d.msg);
      //     break;
      // }
    }
    return d;
  } catch (e) {
    console.log(e);
    console.log("错误", url, token, clientData.auth?.token);
    return { success: false, error: e };
  }
}

export const get = (url, params = {}, options = {}) => request(url + (Object.keys(params).length ? `?${new URLSearchParams(params)}` : ""), "GET", options);
export const post = (url, body, options = {}) => request(url, "POST", { ...options, body: JSON.stringify(body) });
export const formdata = (url, body, options = {}) => {
  const headers = {
    "Content-Type": "multipart/form-data",
  };
  return request(url, "POST", { ...options, body, headers });
};
export const put = (url, body, options = {}) => request(url, "PUT", { ...options, body: JSON.stringify(body) });
export const del = (url, options = {}) => request(url, "DELETE", options);
